import { register, getPrefix } from '../../../Utils'

const CoursesCongresses = el => {
  const prefix = getPrefix(el)

  const filterForm = el.querySelector(`.${prefix}filter-form`)
  const pageField = el.querySelector(`.${prefix}page-field`)
  const submitButton = el.querySelector(`.${prefix}filter-submit`)
  const resetButton = el.querySelector(`.${prefix}filter-reset`)
  const resultsContainer = el.querySelector(`.${prefix}results-container`)

  let pageLinks

  const changePage = e => {
    const targetPage = e.currentTarget.dataset.pageNumber
    pageField.value = targetPage
    submitForm()
  }

  const buildPagination = () => {
    pageLinks = el.querySelectorAll(`.ajax-page-link`)
    console.log(el)
    console.log(pageLinks)
    pageLinks.forEach(pageLink => pageLink.addEventListener('click', changePage))
  }

  const fetchFormData = async (url = '', data = {}) => {
    const response = await fetch(url, {
      method: 'POST',
      body: data
    })
    return response.text()
  }

  const submitForm = e => {
    el.classList.add(`${prefix}is--loading`)
    const formData = new FormData(filterForm)

    fetchFormData(filterForm.action, formData)
      .then((data) => {
        resultsContainer.innerHTML = data
        buildPagination()
        el.classList.remove(`${prefix}is--loading`)
        resultsContainer.scrollIntoView({behavior: 'smooth'})
      })
      .catch(error => {
        el.classList.remove(`${prefix}is--loading`)
        console.log('Request failed: ', error)
      })
  }

  buildPagination()
  submitButton.addEventListener('click', submitForm)
  resetButton.addEventListener('click', () => window.location.reload())
}

register('CoursesCongresses', CoursesCongresses)
